import { Injectable, SecurityContext } from '@angular/core';
import { EvidenciaOportunidad } from 'src/app/shared/model/gestion-proyectos/evidenciasOportunidad';
import { Msg } from '../mensajes/Msg';
import { ModalEvidenciaOportunidadComponent } from 'src/app/proceso-operativo/oportunidades/modal-evidencia-oportunidad/modal-evidencia-oportunidad.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
  })
export class ArchivosUtileriasService {
  constructor(
    protected msg: Msg,
    protected dialog: MatDialog,
    protected sanitizer: DomSanitizer
  ) {}

  public obtenerImagenTipoArchivo(tipo: string): string {
    switch (tipo) {
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return "./assets/img/archivos/word-icon.png";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
        return "./assets/img/archivos/excel-icon.png";
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return "./assets/img/archivos/ppt-icon.png";
      case "application/pdf":
        return "./assets/img/archivos/pdf-icon.png";
      case "image/jpeg":
      case "image/png":
        return "./assets/img/archivos/image-icon.png";
      case "text/plain":
        return "./assets/img/archivos/text-icon.png";
      default:
        return "./assets/img/archivos/doc-icon.png";
    }
  }

  public descargarArchivo(archivoContenido:string, nombre, tipo): void {
    if (archivoContenido) {
      const byteCharacters = atob(archivoContenido);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.codePointAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([this.toBlobPart(byteArray)], { type: tipo });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombre;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else
      this.msg.showErrorNotification(
        "top",
        "No fue posible descargar el archivo"
      );
  }

  public mostrarVistaPreviaTipoArchivo(
    archivo: EvidenciaOportunidad,
    contenidoArchivo: string
  ): void {
    switch (archivo.type) {
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
      case "text/plain":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      case "application/vnd.ms-excel.sheet.macroEnabled.12":
        this.mostrarVistaPreviaArchivo(contenidoArchivo, archivo, false);
        break;
      // El contenido llega del servidor: pasa por el saneador de Angular en vez
      // de saltárselo. Con el prefijo data:image fijo lo deja pasar tal cual.
      case "image/jpeg":
        this.mostrarVistaPreviaArchivo(
          this.sanitizer.sanitize(
            SecurityContext.URL,
            "data:image/jpg;base64," + contenidoArchivo
          ),
          archivo,
          true
        );
        break;
      case "image/png":
        this.mostrarVistaPreviaArchivo(
          this.sanitizer.sanitize(
            SecurityContext.URL,
            "data:image/png;base64," + contenidoArchivo
          ),
          archivo,
          true
        );
        break;
      case "application/pdf": {
        const binaryString = atob(contenidoArchivo);
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          byteArray[i] = binaryString.codePointAt(i);
        }
        this.loadPdf(byteArray);
        break;
      }
      default:
        this.msg.showErrorNotification("top", "Tipo de archivo inválido.");
    }
  }
  private mostrarVistaPreviaArchivo(
    archivoContent: any,
    archivoDatos: EvidenciaOportunidad,
    mostrar: boolean
  ) {
    this.dialog.open(ModalEvidenciaOportunidadComponent, {
      panelClass: "custom-modalbox",
      data: {
        imagen: archivoContent,
        NombreEvidencia: archivoDatos.name,
        show: mostrar,
        type: archivoDatos.type,
      },
    });
  }
  private loadPdf(bit: Uint8Array) {
    const pdfBytes = bit;
    if (pdfBytes) {
      const blob = new Blob([this.toBlobPart(pdfBytes)], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");
    }
  }

  private toBlobPart(bytes: Uint8Array): ArrayBuffer {
    const normalizedBytes = new Uint8Array(bytes.byteLength);
    normalizedBytes.set(bytes);
    return normalizedBytes.buffer;
  }

  public agregarCargaArchivo(nombreInpuFile:string, listaArchivosAgregar: any[], regexFormato: RegExp): any[] {
    const input = <HTMLInputElement>(
      document.getElementById(nombreInpuFile)
    );

    if (input.files && input.files.length > 0) {
      for (const file of Array.from(input.files)) {
        if (!regexFormato.test(file.name)) {
          this.msg.showErrorNotification(
            "top",
            "El archivo '" +
              file.name +
              "' no se encuentra en la lista de formatos válidos."
          );
        } else {
          const exists = listaArchivosAgregar.some(
            (existingFile) =>
              existingFile.name === file.name && existingFile.size === file.size
          );

          if (!exists) {
            listaArchivosAgregar.push(file);
          }
        }
      }
    }
    input.value = "";
    return listaArchivosAgregar;
  }

  public removerCargaArchivo(nombreInpuFile:string, listaArchivosAgregar: any[], listaArchivosAgregarSelect: any[]):  any[] {
    let index: number;
    for (const option of listaArchivosAgregarSelect) {
      index = listaArchivosAgregar.findIndex(
        (item) => item.name == option.name
      );
      listaArchivosAgregar.splice(index, 1);
    }
    (<HTMLInputElement>document.getElementById(nombreInpuFile)).value =
      "";
    return listaArchivosAgregar;
  }


}
